namespace SorAraBul {
    export enum UserType {
        bireysel = 0,
        kurumsal = 1
    }
    Serenity.Decorators.registerEnumType(UserType, 'SorAraBul.UserType');
}
